module.exports = __webpack_public_path__ + "img/xiaomi_newsfeed_image.28591dae.jpg";